import { render, staticRenderFns } from "./DefineProblemTool.vue?vue&type=template&id=684833a1"
import script from "./DefineProblemTool.vue?vue&type=script&lang=js"
export * from "./DefineProblemTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports